import { Checkbox, CheckboxProps, FormControl, FormControlLabel, FormHelperText } from '@material-ui/core';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// import styles from './SGSCheckbox.module.scss';

type TriggerByName = {
    trigger: Function;
    name: string;
};

export type SGSCheckboxProps = CheckboxProps & {
    error?: boolean;
    label?: string;
    helperText?: string;
    name?: string;
    handleChange?: Function;
    trigger?: Function;
    triggerByName?: TriggerByName | null;
    readOnly?: boolean;
};

const SGSCheckbox: React.FC<SGSCheckboxProps> = ({ error, label, helperText, name, handleChange, trigger, triggerByName, readOnly = false, ...props }) => {
    const { control } = useFormContext();

    return (
        <FormControl error={error}>
            <Controller
                rules={{ required: true }}
                control={control}
                name={name}
                render={({ field: { onChange } }) => (
                    <>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    {...props}
                                    checked={props.checked}
                                    onChange={(e) => {
                                        if (!readOnly) {
                                            onChange(e.target.checked);
                                            if (handleChange) handleChange(e.target.checked, name);
                                            if (trigger) trigger(name);
                                            if (triggerByName) triggerByName.trigger(triggerByName.name);
                                        }
                                    }}
                                />
                            }
                            label={label}
                            className="mb-0"
                        />
                        {helperText && <FormHelperText>{helperText}</FormHelperText>}
                    </>
                )}
            />
        </FormControl>
    );
};

export default SGSCheckbox;
